import { Component, effect, Signal, signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { FeatureFlag } from '@app/enums/feature-flag.enum';
import { FeatureService } from '@app/services/feature.service';
import { HelpItem } from '../../components/help/help.component';
import { NavGroup } from '../../components/side-nav/side-nav.component';
import { OnboardingStatusService } from '../../services/onboarding-status.service';
import { OnboardingStatus } from '../../services/types';

@Component({
    templateUrl: './payroll-documents.template.html',
    styleUrls: ['../../self-serve.style.scss'],
})
export class PayrollDocumentsView {
    navGroups: NavGroup[] = [];
    helpItems: HelpItem[] = [];
    private onboardingStatus: Signal<OnboardingStatus | null> = signal<OnboardingStatus | null>(null);
    private isKYBEnabled = signal(false);

    /**
     * NavGroups are only necessary if KYB is not enabled for the user since they would need to access both supporting and authorization documents sub-pages
     */
    private setNavGroups = effect(() => {
        if (this.isKYBEnabled()) {
            this.setNavGroups.destroy();
            return;
        }
        this.navGroups = [
            {
                title: 'self-serve.payrollDocuments.preparePayrollDocuments',
                steps: [
                    {
                        text: 'self-serve.payrollDocuments.sideNav.authorizationDocuments',
                        href: 'authorization-documents',
                        complete: this.onboardingStatus()?.payrollDocuments.steps.authorizationDocuments ?? false,
                    },
                    {
                        text: 'self-serve.payrollDocuments.sideNav.supportingDocuments',
                        href: 'supporting-documents',
                        complete: this.onboardingStatus()?.payrollDocuments.steps.supportingDocuments ?? false,
                    },
                ],
            },
        ];
    });

    constructor(
        private onboardingStatusService: OnboardingStatusService,
        private featureService: FeatureService
    ) {
        this.featureService.has(FeatureFlag.KYC_KYB).then(this.isKYBEnabled.set);
        this.onboardingStatus = toSignal(this.onboardingStatusService.onboardingStatus$, { requireSync: true });
    }
}
